module.exports = __webpack_public_path__ + "static/img/10.52b1977.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/10.png
// module id = q91k
// module chunks = 0